export * from './types';
export { resolve } from './resolve';
export { quickFix } from './quick-fix';
export type { QuickFixList } from './quick-fix';
export {
  GraphRelativeParser,
  GraphRelativeParserForRel,
} from './graph-relative-parser';
export type { RelativeParser } from './graph-relative-parser';
export { prettyPrintGraphError as prettyPrint } from './types';
export type { IToolResolver } from './types';

/**
 * The rules are as follows:
 *  1. If it's all alphanumeric do it as `%foo`
 *  2. If it contains weird characters wrap it in `%"some name"` and escape all the double quotes inside of it
 */
export const symbolEraQL = (symbol: string): string =>
  /^[a-zA-Z_0-9]+$/.test(symbol)
    ? `%${symbol}`
    : `%"${symbol.replaceAll(`"`, `\\"`)}"`;
